export const AUTHENTICATION_TYPES = {
  LINKEDIN: "LINKEDIN",
  COGNITO: "COGNITO",
};
